<template>
  <v-app>
    <v-app-bar
      app
      clipped-right
      flat
      height="72"
      color="navy lighten-3"
      class="mx-4"
    >
      <!--      <PageSelect />-->
      <v-spacer />
      <UserMenu />
      <MenuToggler />
    </v-app-bar>

    <Drawer />

    <v-main class="navy lighten-3">
      <router-view />
    </v-main>

    <!--
      <v-footer app color="transparent" height="72" inset>
        <portal-target name="footer" />
      </v-footer>
    -->
  </v-app>
</template>

<script>
import Drawer from "./Drawer.vue"
import UserMenu from "./UserMenu.vue"
// import PageSelect from "./PageSelect.vue"
import MenuToggler from "../../ui/MenuToggler"

export default {
  components: {
    Drawer,
    UserMenu,
    MenuToggler,
    // PageSelect,
  },
}
</script>

<style scoped>
.v-list-item--link:before {
  background: #fef4e4;
  z-index: -1;
}

.v-list--nav .v-list-item--link:before {
  border-radius: 6px;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 1;
}

.c-menu-icon {
  color: var(--v-navy-lighten1);
}

.c-menu-icon.c-menu-icon--nested-mode {
  color: white;
}

.v-list-item--active .c-menu-icon:not(.c-menu-icon--nested-mode) {
  color: var(--v-amber-base);
}

.c-menu-text {
  color: var(--v-primary-base);
}

.c-menu-text--nested-mode {
  color: white;
}

.v-list-item--disabled .c-menu-text {
  color: var(--v-navy-lighten1);
}

.v-list-item--disabled .c-menu-text--nested-mode {
  color: var(--v-navy);
}
</style>
